import getStore from '../data/store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import DeclineMeetingSelectionState from '../data/store/schema/DeclineMeetingSelectionState';
export function getIsAutomaticReplyEnabled() {
    var optionsState = getStore().currentState;
    var initialState = getStore().initialState;
    return getFallbackValueIfNull(optionsState.isAutomaticReplyEnabled, initialState.isAutomaticReplyEnabled);
}
export function getPeriodicReplyEnabled() {
    var optionsState = getStore().currentState;
    var initialState = getStore().initialState;
    return getFallbackValueIfNull(optionsState.periodicReplyEnabled, initialState.periodicReplyEnabled);
}
export function getBlockCalendarEnabled() {
    var optionsState = getStore().currentState;
    var initialState = getStore().initialState;
    return getFallbackValueIfNull(optionsState.blockCalendarEnabled, initialState.blockCalendarEnabled);
}
export function getBlockCalendarTitle() {
    var optionsState = getStore().currentState;
    var initialState = getStore().initialState;
    return getFallbackValueIfNull(optionsState.blockCalendarTitle, initialState.blockCalendarTitle);
}
export function getDeclineExistingCalendarEventsEnabled() {
    var optionsState = getStore().currentState;
    var initialState = getStore().initialState;
    return getFallbackValueIfNull(optionsState.declineExistingCalendarEventsEnabled, initialState.declineExistingCalendarEventsEnabled);
}
export function getDeclineNewInvitationsEnabled() {
    var optionsState = getStore().currentState;
    var initialState = getStore().initialState;
    return getFallbackValueIfNull(optionsState.declineNewInvitationsEnabled, initialState.declineNewInvitationsEnabled);
}
export function getEditorViewStateMessageContent() {
    var optionsState = getStore().currentState;
    var initialState = getStore().initialState;
    return getFallbackValueIfNull(optionsState.editorViewStateMessage.content, initialState.editorViewStateMessage.content);
}
export function getEditorViewStateDeclineMeetingContent() {
    var optionsState = getStore().currentState;
    var initialState = getStore().initialState;
    return getFallbackValueIfNull(optionsState.editorViewStateDeclineMeeting.content, initialState.editorViewStateDeclineMeeting.content);
}
export function getEditorViewStateOutsideOrgContent() {
    var optionsState = getStore().currentState;
    var initialState = getStore().initialState;
    return getFallbackValueIfNull(optionsState.editorViewStateOutsideOrg.content, initialState.editorViewStateOutsideOrg.content);
}
export function getSendRepliesOutsideOrgEnabled() {
    var optionsState = getStore().currentState;
    var initialState = getStore().initialState;
    return getFallbackValueIfNull(optionsState.sendRepliesOutsideOrgEnabled, initialState.sendRepliesOutsideOrgEnabled);
}
export function getSendRepliesToContactsOnlyEnabled() {
    var optionsState = getStore().currentState;
    var initialState = getStore().initialState;
    return getFallbackValueIfNull(optionsState.sendRepliesToContactsOnlyEnabled, initialState.sendRepliesToContactsOnlyEnabled);
}
export function getStartDate() {
    var optionsState = getStore().currentState;
    var initialState = getStore().initialState;
    return getFallbackValueIfNull(optionsState.startDate, initialState.startDate);
}
export function getEndDate() {
    var optionsState = getStore().currentState;
    var initialState = getStore().initialState;
    return getFallbackValueIfNull(optionsState.endDate, initialState.endDate);
}
export function getDeclineMeetingSelectedCategoryKey() {
    var optionsState = getStore().currentState;
    return getFallbackValueIfNull(optionsState.declineMeetingSelectedCategoryKey, DeclineMeetingSelectionState.UseAutomaticReplyMessage);
}
//# sourceMappingURL=getStoreProperties.js.map